export enum ReactivationSteps {
  FORM = 'FORM',
  RESUME = 'RESUME',
}
